<script setup lang="ts">
import { ListDefinition } from "~/api";
import { onMounted, ref } from "vue";

import { LabelledOption } from "~/api";

const props = defineProps<{
  formDefinitionGuid: string;
  listDefinitions: ListDefinition[];
  readOnly?: boolean;
}>();

const emit = defineEmits(["updated"]);
const modelValue = defineModel<LabelledOption[]>({ required: true });

/** these are all the available lists */
const selectedList = ref<ListDefinition>();

const handleChange = (newVal: ListDefinition) => {
  if (!newVal) {
    modelValue.value = [];
    return;
  }
  if (modelValue.value !== newVal.items) {
    modelValue.value = newVal.items.map((item) => ({
      value: item.value,
      label: item.label,
      // this is for the recursive lists
      children: [],
    }));
  }
};

onMounted(async () => {
  // Use the modelValue to set the selected list ref
  const modelList = modelValue.value || [];
  if (modelList.length > 0) {
    const selected = props.listDefinitions.find((list) =>
      // Check if all modelList items are included in list.items (by value and label)
      modelList.every((modelItem) =>
        list.items.some(
          (listItem) =>
            listItem.value === modelItem.value &&
            listItem.label === modelItem.label,
        ),
      ),
    );

    if (selected) {
      selectedList.value = selected;
    }
  }
});
</script>

<template>
  <div class="ListSelector">
    <el-select
      v-model="selectedList"
      class="select-button"
      clearable
      placeholder="Select a list"
      value-key="listDefinitionGuid"
      :disabled="props.readOnly"
      @change="handleChange"
    >
      <el-option
        v-for="list in props.listDefinitions"
        :key="list.listDefinitionGuid"
        :label="list.name"
        :value="list"
      />
    </el-select>
  </div>
</template>

<style lang="less">
.ListSelector {
  width: 100%;
  .select-button {
    margin: 5px 0 20px 0;
  }
}
</style>
